
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Loading',
})
export default class Alert extends Vue {}
